import { render, staticRenderFns } from "./song_information.vue?vue&type=template&id=65e9f07b&"
import script from "./song_information.vue?vue&type=script&lang=js&"
export * from "./song_information.vue?vue&type=script&lang=js&"
import style0 from "./song_information.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports